import { Site } from '@models/account/site.model';
import { FocusRange } from '@models/focus-range.model';

import { ApiAdapter } from './adapter';

export class FocusRangeAdapter extends ApiAdapter<FocusRange> {
  get(json): FocusRange {
    return new FocusRange({
      contractId: json['contract_id'],
      accountId: json['account_id'],
      site: json['site_id']
        ? new Site({
            id: json['site_id'],
            labels: { external: json['site_name'], internal: json['site_name'] },
          })
        : null,
    });
  }
}
